import * as TYPES from './Redux.actionTypes.js'

export const setNavIsOpen = value => ({ type: TYPES.SET_NAV_DRAWER_IS_OPEN, value });

export const setDisplayedWeek = value => ({ type: TYPES.SET_DISPLAYED_WEEK, value });

export const setDisplayedMonth = value => ({ type: TYPES.SET_DISPLAYED_MONTH, value });

export const setDevotionalGroupLeader = value =>
  ({ type: TYPES.SET_DEVOTIONAL_GROUP_LEADER, value });

export const setSelectedDevotionalGroup = value =>
  ({ type: TYPES.SELECTED_DEVOTIONAL_GROUP, value });

export const setAttendance = value =>
  ({ type: TYPES.SET_ATTENDANCE, value });

export const setIsInitialLoading = value =>
    ({ type: TYPES.SET_IS_INITIAL_LOADING, value });

export const initializeApp = value =>
    ({ type: TYPES.INITIALIZE_APP, value });

export const setLoggedInDevoteeId = value =>
  ({ type: TYPES.SET_LOGGED_IN_DEVOTEE_ID, value });

export const setIsAuthorized = value =>
 ({ type: TYPES.SET_IS_AUTHORIZED, value });

export const setIsAuthenticated = value =>
  ({ type: TYPES.SET_IS_AUTHENTICATED, value });
